import { BOOKMARK_ADD, BOOKMARK_LIST, BOOKMARK_DEL } from 'actions/bookMark';

const defaultState = {
  listResult: { data: null }
};
function bookMark(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${BOOKMARK_ADD}_FULFILLED`:
      return {
        ...state,
        addResult: payload
      };

    case `${BOOKMARK_ADD}_REJECTED`:
      return {
        ...state,
        addResult: payload
      };

    case `${BOOKMARK_ADD}_PENDING`:
      return {
        ...state,
        addResult: payload
      };

    case `${BOOKMARK_LIST}_FULFILLED`:
      return {
        ...state,
        listResult: payload
      };

    case `${BOOKMARK_LIST}_REJECTED`:
      return {
        ...state,
        listResult: payload
      };

    case `${BOOKMARK_LIST}_PENDING`:
      return {
        ...state,
        listResult: payload
      };

    case `${BOOKMARK_DEL}_FULFILLED`:
      return {
        ...state,
        delResult: payload
      };

    case `${BOOKMARK_DEL}_REJECTED`:
      return {
        ...state,
        delResult: payload
      };

    case `${BOOKMARK_DEL}_PENDING`:
      return {
        ...state,
        delResult: payload
      };

    default:
      return state;
  }
}

export default bookMark;
